'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const ListPrice = renderWithRef('ListPrice', null, (t, s)=>{
    let { children: o } = t;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: s,
        classNames: new Set([
            'swan-list-price'
        ]),
        props: t,
        children: o
    });
});

export { ListPrice };
